(function(jQuery)
{
	jQuery.framework = jQuery.framework || {};
	
	/*
	* width = width to expand - takes any unit
	* canvas = the item which is hidden
	* cover = the cover (should only need one per page - unless different styling is needed for each cover)
	* tigger = the element which shoudl trigger the expansion (restration is provided by the cover) - can take an array
	* alignment = from the "left" (default) or from teh "right")
	*/
	jQuery.framework.offcanvas = function(width, canvas, cover, trigger, alignment)
	{
		if(alignment == "left")
		{
			var bodyAnimation = {"left": width};
			var bodyAnimationRetract = {"left": 0};
			jQuery(canvas).css("left", "-" + width);
			
		}
		else if(alignment == "right")
		{
			var bodyAnimation = {"left": "-" + width};
			var bodyAnimationRetract = {"left": 0};
			jQuery(canvas).css("right", "-" + width);
		}
		else
		{
			throw new Error("incorrect alignment value");
		}
		
		jQuery(canvas).css("width", width);
		jQuery(cover).css("display", "none");
		
		jQuery(trigger).bind("click", expand);
		jQuery(cover).bind("click", retract);
		
		function expand()
		{
			jQuery(cover).css("display", "block");
			
			jQuery(canvas).css("position", "absolute");
			jQuery(trigger).unbind("click");
			jQuery("body").css("overflowX", "hidden");
			jQuery("body").animate(bodyAnimation,
				function()
				{
					jQuery(trigger).bind("click", retract);
					jQuery(cover).css("pointerEvents", "all");
				}
			);

			jQuery(cover).animate(
				{
					opacity: 0.5
				}
			);
		}
		
		function retract()
		{
			jQuery(trigger).unbind("click");
			jQuery("body").animate(bodyAnimationRetract,
				function()
				{
					jQuery(trigger).bind("click", expand);
					jQuery(cover).css("pointerEvents", "none");
					jQuery(canvas).css("position", "absolute");
					
					jQuery(cover).css("display", "none");
				}
			);
			jQuery(cover).animate(
				{
					opacity: 0.0
				}
			);	
		}
		
		jQuery(canvas).css("display", "block");

	}
})(jQuery);
